import React, { ReactNode } from "react";

type OnboardingPageCopyProps = {
    children: ReactNode;
}

export const OnboardingPageCopy = (props: OnboardingPageCopyProps) => {
    return <div className="onboarding-page__content--copy">{props.children}</div>
}